import * as React from "react"
import Navigation from "templates/global/Navigation";
import UtilNavigation from "templates/global/UtilNavigation";

import Icon from 'components/Icon'
import Link from 'components/Link'
import logo from 'images/logo.svg';

const Header = ({ open, isOpen, close, label }) => {
	const svgSwapSize = isOpen ? "40px" : "30px";

	const [searchOpen, setSearchOpen] = React.useState(false)

	const handleSearchBar = (e) => {
		e.preventDefault()
		setSearchOpen(!searchOpen)
	}
	
	return (
		<header id="mainHeader">
			<nav className="util hide-for-small-only">
				<div className="grid-container">
					<div className="grid-x grid-padding-x">
						<div className="cell auto text-right">
							<UtilNavigation />
						</div>
                        <div className="cell shrink text-right search-holder">
                            <ul>
                                <li className={`search-li`}>
									<form className={`${searchOpen ? "grow" : ""}`} action="/search/" method="GET">
										<button aria-label="Search" type="submit"><Icon symbol={'search'} width="19px" height="19px" /></button>
										<input className={`${searchOpen ? "grow" : ""}`} type="text" name="keywords" placeholder="Search" />
										<button className="search-trigger" onClick={handleSearchBar} aria-label={searchOpen ? 'Close' : 'Search'}>{searchOpen ? <Icon symbol={'close'} width="19px" height="19px" /> : <Icon symbol={'search'} width="19px" height="19px" /> }</button>
									</form>
								</li>
                            </ul>
                        </div>
					</div>
				</div>
			</nav>
			<nav className="main">
				<div className="grid-container">
					<div className="grid-x grid-padding-x" style={{ alignItems: "center" }}>
						<div className="cell small-6 medium-2 large-2 logoWrapper">
							<Link to={`/`}><img src={logo} alt="Walton County Tourism Logo" /></Link>
						</div>
						<div className="cell small-auto medium-10 large-9 text-right hide-for-small-only">
							<Navigation />
						</div>
						<div className="cell small-6 text-right show-for-small-only">
							<div className="linkWrapper">
								<Icon onClick={isOpen ? close : open} width={svgSwapSize} height={svgSwapSize} symbol={isOpen ? "close" : "hamburger"} />
							</div>
						</div>
					</div>
				</div>
			</nav>
		</header>
	)
}


export default Header
